import InfoCircle from './InfoCircle';

export default InfoCircle;
